import { DotsCheckbox } from "dots-ui/dotsCheckbox";
import { FormikProps } from "formik";
import { useContext } from "react";
import {
  CreationsListFilter,
  ItemViewModel,
} from "../../../../../generated/data-contracts";
import { FormikUtils } from "../../../../../utils";
import { FilterActions } from "../../../../shared/components/form";
import {
  AvisDropdown,
  AvisInputTextWithFilterType,
} from "../../../../shared/components/inputs";
import { AvisContext } from "../../../../shared/context/AvisContext";
import { isMobileView } from "../../../../shared/appStates/appStates";

interface ICreationsFilterFormProps {
  bag: FormikProps<CreationsListFilter>;
  creationClasses: ItemViewModel[];
  creationStatusList: ItemViewModel[];
  defaultCreationTypeId?: number;
  loading: boolean;
  filtered: boolean;
}

export function CreationsFilterForm(
  props: Readonly<ICreationsFilterFormProps>,
) {
  const {
    bag,
    loading,
    creationClasses,
    creationStatusList,
    filtered,
    defaultCreationTypeId,
  } = props;
  const { res } = useContext(AvisContext);
  const classnameFields = isMobileView.value ? "col-10" : "col-5";

  return (
    <>
      <div className="row">
        <AvisDropdown<ItemViewModel, CreationsListFilter>
          label={res("label_CreationClassName")}
          className={classnameFields}
          options={creationClasses}
          bag={bag}
          bagField="creationClassId"
          disabled={loading || !!defaultCreationTypeId}
          optionValue="id"
          optionLabel="name"
        />
        <AvisDropdown<ItemViewModel, CreationsListFilter>
          label={res("authors_CreationsPage_Filter_CreationStatus")}
          className={classnameFields}
          options={creationStatusList}
          bag={bag}
          bagField="creationStatusId"
          disabled={loading}
          optionValue="id"
          optionLabel="name"
        />
      </div>
      <div className="row">
        <AvisInputTextWithFilterType<CreationsListFilter>
          className={classnameFields}
          label={res("authors_Creation_label_CreationName")}
          bag={bag}
          bagField="creationName"
          bagFieldFilterType="creationNameFilterType"
          disabled={loading}
          minLength={2}
          maxLength={200}
          onKeyDown={(e) => FormikUtils.handleEnterKeyPress(e, bag.submitForm)}
        />
      </div>
      <div className="row">
        <div className="col-12">
          <DotsCheckbox<CreationsListFilter>
            checkboxLabel={res("label_SearchAllCreationNames")}
            bag={bag}
            bagField="searchAllNames"
            disabled={loading}
          />
        </div>
      </div>
      <FilterActions
        bag={bag}
        loading={loading}
        res={res}
        filtered={filtered}
      />
    </>
  );
}
